import { authService } from './authService';

/** The permission that lets a caller act as another user (Run-As-User-Impersonation spec). */
export const IMPERSONATE_PERMISSION = 'Nexo.Users.Impersonate';

/** ABP Identity's own permission — the Users page calls /api/identity/users. */
const USERS_PERMISSION = 'AbpIdentity.Users';

/**
 * Where returning from "Run as user" lands: the page the next one is started from. The Users page
 * when the operator may open it; otherwise "Run as user", which a support session reaches with the
 * impersonation permission alone (D14); otherwise home, whose own landing logic takes over.
 */
export function returnToAdminPath(permissions: readonly string[]): string {
  if (permissions.includes(USERS_PERMISSION)) return '/core/users';
  if (permissions.includes(IMPERSONATE_PERMISSION)) return '/core/run-as';
  return '/';
}

/**
 * End impersonation and reload into the original identity — the one exit both the "Return to
 * admin" button and an expired impersonation token take. A full reload (D13b): the silent round
 * restores the original identity from the auth-host cookie and resumes at the chosen path, and the
 * reload drops the React Query cache holding data fetched as the impersonated user.
 *
 * The path is chosen from the permissions endImpersonation re-read with the original token, never
 * from the impersonated user's.
 */
export async function returnToAdmin(): Promise<void> {
  const permissions = await authService.endImpersonation();
  authService.clearSilentAttempt();
  window.location.assign(returnToAdminPath(permissions));
}
